import * as Sentry from '@sentry/react';
import React from 'react';

type Props = {
  children: React.ReactNode;
};

export function AppErrorBoundary({ children }: Props) {
  return (
    <Sentry.ErrorBoundary
      showDialog={false}
      fallback={
        <div style={{ padding: 24, textAlign: 'center' }}>
          <p>Něco se pokazilo.</p>
          <button type="button" onClick={() => window.location.reload()}>
            Obnovit stránku
          </button>
        </div>
      }
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
